import LedgerMiniIcon from './LedgerMiniIcon'

export default LedgerMiniIcon
